import styles from 'components/layout/event/EventDetailQuizRow.module.scss';
import classNames from "classnames";
import FullButton from "components/buttons/FullButton";
import {ordersRoute} from "common/const";
import Link from "next/link";
import ArrowRightIcon from "images/icons/arrow_right_757575.svg";
import {customAlert} from "common/utils";
import ModalContext from "context/ModalContext";
import {useEffect, useRef, useState} from "react";
import {Axios} from "api";
import {redirectToLogin} from "common/redirect";
import {captureException, captureMessage} from "@sentry/nextjs";
import {toast} from "react-toastify";
import {useRouter} from "next/router";


const Marker = (props) => {
    const {text, isLight} = props;
    return (
        <div className={classNames(styles.marker, isLight ? styles.lightColor : styles.color)}>
            <span>{text}</span>
        </div>
    )
};

export const EventDetailQuizRow = (props) => {
    const {
        quizNumber, point, title, choices, hintLink, answerIdx, moldKey, receivedCouponMoldKeysRef, isLoading, setIsLoading
    } = props;

    const router = useRouter();

    const onHintClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'EventDetailQuizRowHintButtonClick',
            {
                quizNumber,
            }
        );
    };

    const isReceived = receivedCouponMoldKeysRef.current.includes(moldKey);

    const receiveCoupon = async () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('EventDetailQuizRowCouponDownload', {
            mold_key: moldKey,
        });

        if (isReceived) {
            toast.info('이미 정답을 맞추셨어요!');
            return;
        }

        if (isLoading) {
            customAlert('로딩중입니다. 잠시만 기다려주세요.', '확인', () => {});
            return;
        }

        setIsLoading(true);
        try {
            const data = {
                mold_key: moldKey,
            }
            const res = await Axios.post('v1/coupons/download', data);
            if (res.status < 400) {
                receivedCouponMoldKeysRef.current.push(moldKey);
                customAlert('정답입니다. 포인트가 지급되었습니다!', '확인', () => {});
            } else if (res.status === 401) {
                redirectToLogin(router, true);
            } else {
                captureMessage(JSON.stringify(res.data));
                toast.info(res.data.display_message || '일시적인 오류로 포인트 지급에 실패했습니다. 잠시 후 시도해주세요.');
            }
        } catch (e) {
            captureException(e);
            toast.info('일시적인 오류로 포인트 지급에 실패했습니다. 잠시 후 다시 시도해주세요.');
        } finally {
            setIsLoading(false);
        }
    };

    const onChoiceClick = (choiceIdx) => {
        const isCorrect = answerIdx === choiceIdx;
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'EventDetailQuizRowChoiceClick',
            {
                quizNumber,
                choiceIdx,
                isCorrect,
            }
        );
        if (isCorrect) {
            receiveCoupon();
        } else {
            customAlert('아쉬워요. 다시 한 번 생각해보세요!', '확인', () => {});
        }
    };

    const isOX = choices.length === 2 && choices[0] === 'O' && choices[1] === 'X';

    return (
        <div>
            <div className={styles.markerList}>
                <Marker text={`Q${quizNumber}`}/>
                <Marker text={`${point}P`} isLight/>
            </div>
            <div className={styles.quizTitle}>
                {title}
            </div>
            <div className={styles.quizChoices}>
                {
                    isReceived &&
                    <div className={styles.receivedCoupon}>
                        <span>이미 참여한 퀴즈예요</span>
                    </div>
                }
                {
                    choices.map((choice, index) => {
                        return (
                            <div className={classNames(styles.quizChoice, isOX && styles.oxChoice)}
                                 key={`choice-${quizNumber}-${index}`}
                                 onClick={() => onChoiceClick(index)}
                            >
                                {isReceived && <div className={styles.received} />}
                                <span className={
                                    classNames(isOX && (choice === 'O' ? styles.oChoice : styles.xChoice))
                                }>
                                    {choice}
                                </span>
                            </div>
                        )
                    })
                }
            </div>
            {
                hintLink &&
                <>
                    <div style={{height: 24}}/>
                    <Link href={hintLink}>
                        <a onClick={onHintClick}>
                            <FullButton white height={48} fontSize={16} borderRadius={10}>
                                <div className={styles.buttonWrapper}>
                                    <div style={{width: 18}}/>
                                    <span>힌트 보러 갈래요</span>
                                    <ArrowRightIcon className={styles.rightArrow} viewBox="0 0 12 12"/>
                                </div>
                            </FullButton>
                        </a>
                    </Link>
                </>
            }
        </div>
    )
};

export const EventDetailQuizList = (props) => {
    const receivedCouponMoldKeysRef = useRef([]);

    const [isLoading, setIsLoading] = useState(false);


    const moldKeys = [
        '1st_anniversary_quiz_1',
        '1st_anniversary_quiz_2',
        '1st_anniversary_quiz_3',
        '1st_anniversary_quiz_4',
    ];

    const checkReceivedCoupon = async () => {
        const data = {
            mold_keys: moldKeys,
        };
        setIsLoading(true);
        try {
            const res = await Axios.post('v1/coupons/check-received/', data);
            if (res.status < 400) {
                if (res.data.mold_keys) {
                    receivedCouponMoldKeysRef.current = res.data.mold_keys;
                }
            }
        } catch (err) {

        }
        setIsLoading(false);
    };

    useEffect(() => {
        checkReceivedCoupon();
    }, []);


    return (
        <div className={styles.quizList}>
            <EventDetailQuizRow
                quizNumber={1} point={30}
                title={'지난 1년 동안 헤메코랩에서 출시한 [ 헤메코박스 ] 는 총 몇 개일까요?'}
                choices={['그게 뭐죠, 0개🙄', '행운의 숫자, 7개🍀', '🌷당연히 11개🌷', '한달에 하나? 12개!']}
                hintLink={"/store/brands/255"}
                moldKey={moldKeys[0]}
                answerIdx={2}
                receivedCouponMoldKeysRef={receivedCouponMoldKeysRef}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
            />
            <EventDetailQuizRow
                quizNumber={2} point={30}
                title={'헤메코랩의 생일은 언제일까요?'}
                choices={['1월 2일', '1월 12일', '1월 22일', '1월 32일']}
                moldKey={moldKeys[1]}
                answerIdx={0}
                receivedCouponMoldKeysRef={receivedCouponMoldKeysRef}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
            />
            <EventDetailQuizRow
                quizNumber={3} point={20}
                title={'[ 헤메티켓 ] 은 헤어메이크업 스타일링을 저렴하게 받을 수 있는 예약권이에요!'}
                choices={['O', 'X']}
                hintLink={"/reservation/products"}
                moldKey={moldKeys[2]}
                answerIdx={0}
                receivedCouponMoldKeysRef={receivedCouponMoldKeysRef}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
            />
            <EventDetailQuizRow
                quizNumber={4} point={20}
                title={'[2024 헤메코특가로 지갑을 지켜라 ] 기획전은 1년에 총 6번 열려요 '}
                choices={['O', 'X']}
                moldKey={moldKeys[3]}
                answerIdx={0}
                receivedCouponMoldKeysRef={receivedCouponMoldKeysRef}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
            />
        </div>
    )
}
